/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconAccountTree/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconAccountTree({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconAccountTree",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconAccountTree.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-1MNXVi': alignSelf,'--mt-2-1MNXVi': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1MNXVi': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1MNXVi': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1MNXVi': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1MNXVi': opacity,'--w-10-1MNXVi': typeof width === 'number' ? `${width}px` : width,'--h-11-1MNXVi': typeof height === 'number' ? `${height}px` : height,'--a-7-1MNXVi': isAnimated ? animation : "none",'--sd-8-1MNXVi': isAnimated ? strokeDashoffset : 0,'--sd-9-1MNXVi': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconAccountTree.SvgPath"
  data-view-path={viewPath}
 d="M22 11V3h-7v3H9V3H2v8h7V8h2v10h4v3h7v-8h-7v3h-2V8h2v3h7zM7 9H4V5h3v4zm10 6h3v4h-3v-4zm0-10h3v4h-3V5z"
 style={{'--f-12-1MNXVi': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}